"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import '@tabler/icons-react';
import '../Icon/Icon.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { IconDanger } from '../Icon/components/icons/IconDanger.mjs';
import { IconInfo } from '../Icon/components/icons/IconInfo.mjs';
import { IconSuccess } from '../Icon/components/icons/IconSuccess.mjs';
import { IconWarning } from '../Icon/components/icons/IconWarning.mjs';
import locales from '../../../../_virtual/_.locale.json@24b745a6ce9353be513d1f98e927d8d3.mjs';
import { useLocalizedStringFormatter } from 'react-aria';
import { ClearPropsContext } from '../ClearPropsContext/ClearPropsContext.mjs';

const icons = {
  danger: IconDanger,
  info: IconInfo,
  success: IconSuccess,
  warning: IconWarning
};
const AlertIcon = (props) => {
  const { status = "info", ...rest } = props;
  const stringFormatter = useLocalizedStringFormatter(locales);
  const Icon = icons[status];
  const iconProps = {
    status,
    "aria-label": stringFormatter.format(`alertIcon.${status}`),
    ...rest
  };
  return /* @__PURE__ */ jsx(ClearPropsContext, { children: /* @__PURE__ */ jsx(Icon, { ...iconProps }) });
};

export { AlertIcon, AlertIcon as default };
//# sourceMappingURL=AlertIcon.mjs.map
